import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms15e/mocker'

function calResultScore (dataGroups) {
  if (dataGroups.length > 0) {
    return dataGroups.map((dataGroup) => {
      return parseFloat(dataGroup.qtyscor)
    }).reduce((a, b) => {
      return parseFloat(a) + parseFloat(b)
    })
  }
}

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms15e/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    let dteyreap = ''
    let numtime = ''
    if (typeof searchParams !== 'undefined') {
      dteyreap = (typeof searchParams.year !== 'undefined' ? searchParams.year : '')
      numtime = (typeof searchParams.numtime !== 'undefined' ? searchParams.numtime : '')
      sendParams = {
        p_codcomp: (typeof searchParams.codcomp3 !== 'undefined' ? searchParams.codcomp3 : ''),
        p_codaplvl: (typeof searchParams.codaplvl !== 'undefined' ? searchParams.codaplvl : ''),
        p_codempid_query: (typeof searchParams.codemp93 !== 'undefined' ? searchParams.codemp93 : '')
      }
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hrms15e/index/' + dteyreap + '/' + numtime, { params: sendParams })
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hrms15e/dropdowns')
  },
  getDetail (detailParams) {
    let sendParams = {}
    sendParams = {
      p_codform: detailParams.p_codform
    }
    let param = detailParams.p_dteyreap + '/' + detailParams.p_numtime + '/' + detailParams.p_numseq + '/' + detailParams.p_codempid_query + '/' + detailParams.p_codaplvl
    if (isMock) return generator(mocker.detail())
    return instance().get(endpoint + '/hrms15e/detail/' + param, { params: sendParams })
  },
  getDetailCourse (courseParams) {
    const params = courseParams.p_dteyreap + '/' + courseParams.p_numtime + '/' + courseParams.p_numseq + '/' + courseParams.p_codempid_query
    if (isMock) return generator(mocker.detailCourse())
    return instance().get(endpoint + '/hrms15e/detailCours/' + params)
  },
  getSumscore (searchParams) {
    const params = searchParams.p_codempid + '/' + searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + searchParams.p_numseq
    if (isMock) return generator(mocker.sumscore())
    return instance().get(endpoint + '/hrms15e/sumscore/' + params)
  },
  getDetailCourseAddInline (param) {
    const params = param.codcours
    if (isMock) return generator(mocker.detailCourseAddInline(param))
    return instance().get(endpoint + '/hrms15e/codCoursQuery/' + params)
  },
  getCourseGapPopup (popupParams) {
    let searchParams = {
      p_dteyreap: popupParams.p_dteyreap,
      p_numtime: popupParams.p_numtime,
      p_numseq: popupParams.p_numseq,
      p_codempid_query: popupParams.p_codempid_query
    }
    const params = searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + searchParams.p_numseq + '/' + searchParams.p_codempid_query
    if (isMock) return generator(mocker.popupCourseGap())
    return instance().get(endpoint + '/hrms15e/detailCoursPopup/' + params)
  },
  getDetailTab1Desc2 (detailParams) {
    let searchParams = {
      p_dteyreap: detailParams.p_dteyreap,
      p_numtime: detailParams.p_numtime,
      p_numseq: detailParams.p_numseq,
      p_codform: detailParams.p_codform,
      p_codempid_query: detailParams.p_codempid_query,
      p_codaplvl: detailParams.p_codaplvl
    }
    const params = searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + searchParams.p_numseq + '/' + searchParams.p_codform + '/' + searchParams.p_codempid_query + '/' + searchParams.p_codaplvl
    if (isMock) return generator(mocker.detailTab1Desc2())
    return instance().get(endpoint + '/hrms15e/detailTab1Desc2/' + params)
  },
  getDetailTab2Desc2 (detailParams) {
    let searchParams = {
      p_dteyreap: detailParams.p_dteyreap,
      p_numtime: detailParams.p_numtime,
      p_numseq: detailParams.p_numseq,
      p_codempid_query: detailParams.p_codempid_query
    }
    const params = searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + searchParams.p_numseq + '/' + searchParams.p_codempid_query
    if (isMock) return generator(mocker.detailTab2Desc2())
    return instance().get(endpoint + '/hrms15e/detailTab2Desc2/' + params)
  },
  getDetailTab3Desc1 (detailParams) {
    let searchParams = {
      p_dteyreap: detailParams.p_dteyreap,
      p_numtime: detailParams.p_numtime,
      p_numseq: detailParams.p_numseq,
      p_codempid_query: detailParams.p_codempid_query
    }
    const params = searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + searchParams.p_numseq + '/' + searchParams.p_codempid_query
    if (isMock) return generator(mocker.detailTab3Desc1())
    return instance().get(endpoint + '/hrms15e/detailTab3Desc1/' + params)
  },
  getDetailTab3Desc2 (detailParams) {
    let searchParams = {
      p_dteyreap: detailParams.p_dteyreap,
      p_numtime: detailParams.p_numtime,
      p_numseq: detailParams.p_numseq,
      p_codempid_query: detailParams.p_codempid_query
    }
    const params = searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + searchParams.p_numseq + '/' + searchParams.p_codempid_query
    if (isMock) return generator(mocker.detailTab3Desc2())
    return instance().get(endpoint + '/hrms15e/detailTab3Desc2/' + params)
  },
  getDetailTab3Desc3 (detailParams) {
    let searchParams = {
      p_dteyreap: detailParams.p_dteyreap,
      p_numtime: detailParams.p_numtime,
      p_codempid_query: detailParams.p_codempid_query
    }
    const params = searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + searchParams.p_codempid_query
    if (isMock) return generator(mocker.detailTab3Desc3())
    return instance().get(endpoint + '/hrms15e/detailTab3Desc3/' + params)
  },
  getDetailTab3Info (detailParams) {
    let searchParams = {
      p_dteyreap: detailParams.p_dteyreap,
      p_numtime: detailParams.p_numtime,
      p_numseq: detailParams.p_numseq,
      p_codempid_query: detailParams.p_codempid_query
    }
    const params = searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + searchParams.p_numseq + '/' + searchParams.p_codempid_query
    if (isMock) return generator(mocker.detail3Info())
    return instance().get(endpoint + '/hrms15e/detailTab3Info/' + params)
  },
  getDetailTab3InfoDesc2Popup (popupParams) {
    let searchParams = {
      p_dteyreap: popupParams.p_dteyreap,
      p_numtime: popupParams.p_numtime,
      p_kpino: popupParams.p_kpino,
      p_codempid_query: popupParams.p_codempid_query
    }
    const params = searchParams.p_dteyreap + '/' + searchParams.p_numtime + '/' + popupParams.p_numseq + '/' + searchParams.p_kpino + '/' + searchParams.p_codempid_query
    if (isMock) return generator(mocker.popupDetail3InfoDesc2())
    return instance().get(endpoint + '/hrms15e/detailTab3InfoDesc2/' + params)
  },
  postStatusSave ({ saveParams, searchParams }) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms15e/statusSave', saveParams)
  },
  postSendmail ({ sendmailParams, searchParams }) {
    if (isMock) return generator(mocker.send())
    return instance().post(endpoint + '/hrms15e/sendmail', sendmailParams)
  },
  postDetail1Save ({ indexSelected, searchIndex, detail, table }) {
    let paramJson = []
    for (let groupRow of table.rows) {
      let numitem = []
      for (let itemRow of groupRow.numitem) {
        numitem.push({
          numgrup: itemRow.numgrup,
          numitem: itemRow.numitem,
          qtyscor: itemRow.qtyscor + '',
          grdscor: itemRow.grad,
          flgdqtysc: itemRow.flgdqtysc,
          qtyded: ''
        })
      }
      paramJson.push({
        numgrup: groupRow.numgrup,
        qtyscor: groupRow.qtyscor + '',
        desimpro: groupRow.desimpro,
        numitem: numitem
      })
    }

    let qtyscorParam = calResultScore(table.rows)
    qtyscorParam = typeof qtyscorParam !== 'undefined' ? qtyscorParam + '' : ''
    let sendParams = {
      codempid_query: indexSelected.codempid,
      dteyreap: searchIndex.year,
      numtime: searchIndex.numtime,
      numseq: indexSelected.numseq,
      codcomp: indexSelected.codcomp,
      codpos: indexSelected.codpos,
      numlvl: indexSelected.numlvl,
      qtybeh: indexSelected.qtybeh + '',
      qtycmp: detail.qtycmp + '',
      qtykpi: indexSelected.qtykpi + '',
      dteapman: detail.dteapman,
      dteapstr: detail.dteapstr,
      dteapend: detail.dteapend,
      flgappr: indexSelected.flgappr,
      codform: detail.codform,
      qtyscor: qtyscorParam,
      commboss: detail.commboss,
      commemp: detail.commemp,
      flgtypap: indexSelected.flgtypap,
      codaplvl: indexSelected.codaplvl,
      param_json: JSON.stringify(paramJson)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms15e/detailTab1Save', sendParams)
  },
  postDetail2Save ({ indexSelected, searchIndex, detail, table }) {
    let paramJson = []
    for (let groupRow of table.rows) {
      let numitem = []
      for (let itemRow of groupRow.numitem) {
        let qtyscorRow = typeof itemRow.score !== 'undefined' ? itemRow.score + '' : ''
        numitem.push({
          numgrup: itemRow.numgrup,
          numitem: itemRow.numitem,
          qtyscor: qtyscorRow,
          grdscor: itemRow.grad
        })
      }
      let qtyscorGroupRow = typeof groupRow.qtyscor !== 'undefined' ? groupRow.qtyscor + '' : ''
      paramJson.push({
        numgrup: groupRow.numgrup,
        qtyscor: qtyscorGroupRow,
        desimpro: groupRow.desimpro,
        numitem: numitem
      })
    }
    let qtyscorParam = calResultScore(table.rows)
    qtyscorParam = typeof qtyscorParam !== 'undefined' ? qtyscorParam + '' : ''
    let sendParams = {
      codempid_query: indexSelected.codempid,
      dteyreap: searchIndex.year,
      numtime: searchIndex.numtime,
      numseq: indexSelected.numseq,
      codcomp: indexSelected.codcomp,
      codpos: indexSelected.codpos,
      numlvl: indexSelected.numlvl,
      qtybeh: detail.qtybeh + '',
      qtycmp: indexSelected.qtycmp + '',
      qtykpi: indexSelected.qtykpi + '',
      dteapman: detail.dteapman,
      dteapstr: detail.dteapstr,
      dteapend: detail.dteapend,
      flgappr: indexSelected.flgappr,
      codjob: detail.codjob,
      qtyscor: qtyscorParam,
      commboss: detail.commboss,
      commemp: detail.commemp,
      flgtypap: indexSelected.flgtypap,
      codaplvl: indexSelected.codaplvl,
      param_json: JSON.stringify(paramJson)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms15e/detailTab2Save', sendParams)
  },
  postDetail3InfoSave ({ searchIndex, detail3Info }) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms15e/detailTab3Save', detail3Info)
  },
  postDetailCourseSave ({ dataRowsHasFlg, searchIndex }) {
    var params = {}
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      params[i] = {
        'codempid_query': dataRow.codempid_query,
        'dteyreap': dataRow.dteyreap,
        'numtime': dataRow.numtime,
        'numseq': dataRow.numseq,
        'codcours': dataRow.codcours,
        'flg': dataRow.flg
      }
    }
    var sendParams = {
      'param_json': JSON.stringify(params)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms15e/detailCoursSave', sendParams)
  },
  postDelete ({ searchIndex, dataRowsHasFlg }) {
    let param = {
      dteyreap: searchIndex.year,
      numtime: searchIndex.numtime
    }
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
      dataRowsHasFlg[i].codempid_query = dataRowsHasFlg[i].codempid
    }
    let sendParams = {
      param_json: JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.delete())
    return instance().post(endpoint + '/hrms15e/delete', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms15e/index.js